export function getEnv(name: string): string | string[] {
  const runtimeConfig = (window as any)?.config?.[name]
  const buildConfig = import.meta.env[name]
  const result: string = import.meta.env.DEV ? buildConfig || runtimeConfig : runtimeConfig || buildConfig
  return result
}

export function getEnvArray(key: string): string[] {
  const value = getEnv(key);

  try {
    if (typeof value === "string") {
      return value.split(",").map((item: string) => item.trim());
    }

    return [];
  } catch {
    throw new Error(`Failed to parse environment variable "${key}"`);
  }
}
